const o = (o2) => o2 ? "Помилка створення" : "Помилка редагування";
export {
  o as getDefaultErrorMessage
};
//# sourceMappingURL=getDefaultErrorMessage.js.map
